/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 5/7/13
 * Time: 2:14 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var Template = require("templates/trayMenuItem.tmpl");
    var TemplateTxt = require("templates/trayMenuItemText.tmpl");
    var Bubble = require("ui/bubble/Bubble");
    var _ = require("underscore");

    var BUBBLE_HANDLER = "createAndRenderBubble";

    var TrayMenuItemView = Marionette.ItemView.extend({
        template: Template,
        tagName: "div",
        className: "tray-menu-item-container",
        withUIComponents: true,
        events: {
            "click.menuTarget .tray-menu-item": "_menuItemClicked",
            "clickoutside": "_handleOutsideClick"
        },
        modelEvents: {
            "change": "_reRenderItem"
        },

        _buildBubbleEvents: function() {
            var bubbleEvent = {};
            var event = "click.bubbleTarget .tray-menu-item-text";
            var handler = BUBBLE_HANDLER;

            if (this.model.get("bubbleTargetControl")) {
               event = "click.bubbleTarget " + this.model.get("bubbleTargetControl");
            }

            bubbleEvent[event] = handler;

            return bubbleEvent;
        },

        onBeforeRender: function() {
            if (this.model && this.model.get("withBubble")) {
                var events = $.extend(true, this._buildBubbleEvents(), this.events);
                this.delegateEvents(events);
            }
        },

        createAndRenderBubble: function () {
            // only if the item tray should be with bubble and is not on the DOM
            if (this.model.get("withBubble") && _.isUndefined(this.uiComponents[this.model.get("bubbleComponentId")])) {
                this.uiComponents.host$.createAndRender(this.model.get("bubbleComponentId"), {
                    type: Bubble,
                    options: {
                        targetControl: $(this.model.get("bubbleTargetControl"))[0],
                        text: this.model.get("bubbleText"),
                        position: this.model.get("bubblePosition"),
                        icon: this.model.get("bubbleIcon"),
                        showCloseButton: this.model.get("bubbleShowCloseButton"),
                        title: this.model.get("bubbleTitle"),
                        permutation: this.model.get("bubblePermutation"),
                        buttonCaption: this.model.get("bubbleButtonCaption"),
                        buttonCallback: this.model.get("bubbleButtonCallback"),
                        buttonPermutation: this.model.get("bubbleButtonPermutation"),
                        contentView: this.model.get("bubbleContentView")
                    }
                });
            }


        },
        _reRenderItem: function () {
            this.render();
        },
        customTemplateHelpers: function () {
            var trayMenuModel = this.model;
            var iconClass = trayMenuModel.get("iconClass") ? trayMenuModel.get("iconClass").replace(".", "") : "";
            return ({
                iconClass: iconClass
            });
        },
        _menuItemClicked: function () {
            if (this.model) {
                var callback = this.model.get("callback");
                if (_.isFunction(callback)) {
                    var context = this.model.get("context") ? this.model.get("context") : this;
                    callback.call(context);
                }
            }
        },
        getTemplate: function () {
            return this.model.get("type") === this.model.TYPES.TEXT ? TemplateTxt : Template;
        },
        _handleOutsideClick: function () {
            if ((!_.isUndefined(this.uiComponents[this.model.get("bubbleComponentId")]) && (this.model.get("bubbleCloseOutsideClick")))) {
                this.uiComponents[this.model.get("bubbleComponentId")].close();
            }
        },
        triggerClick: function() {
            _.defer(_.bind(function() {
                this[BUBBLE_HANDLER]();
            }, this));
        }
    });
    return TrayMenuItemView;
});
